import { useSearchParams, Link } from 'react-router-dom'
import { CheckCircle, AlertCircle, Clock, ArrowLeft } from 'lucide-react'

export default function ProviderVerifyResult() {
  const [searchParams] = useSearchParams()
  const status = searchParams.get('status') || 'error'
  const message = searchParams.get('message') || ''

  const configs = {
    success: {
      icon: CheckCircle,
      iconColor: 'text-rdc-forest',
      title: 'Business Verified!',
      description: message || 'Your business listing has been verified. Our team will review your claim and activate your provider account shortly.',
    },
    already_verified: {
      icon: CheckCircle,
      iconColor: 'text-rdc-forest',
      title: 'Already Verified',
      description: message || 'This claim has already been verified. If you need assistance, please contact support.',
    },
    expired: {
      icon: Clock,
      iconColor: 'text-rdc-tan',
      title: 'Link Expired',
      description: message || 'This verification link has expired. Please submit a new claim from the Specialists page.',
    },
    error: {
      icon: AlertCircle,
      iconColor: 'text-red-500',
      title: 'Verification Failed',
      description: message || 'Something went wrong. Please try again or contact support.',
    },
  }

  const config = configs[status] || configs.error
  const Icon = config.icon

  return (
    <div className="max-w-md mx-auto mt-12 animate-fade-in">
      <div className="card p-8 text-center">
        <Icon size={56} className={`mx-auto mb-4 ${config.iconColor}`} />
        <h1 className="font-display text-2xl font-semibold text-black mb-3">
          {config.title}
        </h1>
        <p className="text-rdc-dark-gray mb-6">
          {config.description}
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/specialists" className="btn-primary inline-flex items-center justify-center gap-2">
            <ArrowLeft size={18} />
            Back to Specialists
          </Link>
          <a
            href="mailto:support@garage.ridinganddrivingclub.com"
            className="text-sm text-rdc-primary hover:underline"
          >
            Need help? Contact support
          </a>
        </div>
      </div>
    </div>
  )
}
